/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Left_Center_Justify_Left_PosInputs */



/**
* | output |
* | --- |
* | "Center Justify / Left Position" |
*
* @param {Align_Left_Center_Justify_Left_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_left_center_justify_left_pos = /** @type {((inputs?: Align_Left_Center_Justify_Left_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Left_Center_Justify_Left_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Justification Centree / Position Gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zentriert / Linksposition")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allineamento al centro / Posizione a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание по центру / Позиция слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("Justificación al centro / Posición izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("居中对齐/左对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央揃え / 左揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र संरेखित करें / बाएँ ओर स्थित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centralizado / Posicionamento à esquerda")
	return /** @type {LocalizedString} */ ("Center Justify / Left Position")
});